/* Exposure product card: colour swatches preview their variant image.
   Delegated on document so cards re-rendered by collection filtering keep working. */
(() => {
  if (window.__xcInit) return;
  window.__xcInit = true;

  const show = (card, src, srcset) => {
    const img = card.querySelector('[data-xc-main]');
    if (!img || !src) return;
    if (!img.dataset.xcOrigSrc) {
      img.dataset.xcOrigSrc = img.getAttribute('src') || '';
      img.dataset.xcOrigSrcset = img.getAttribute('srcset') || '';
    }
    img.setAttribute('srcset', srcset || '');
    img.setAttribute('src', src);
    card.classList.add('is-previewing');
  };

  const restore = (card) => {
    const active = card.querySelector('.xc-swatch.is-active');
    if (active) return show(card, active.dataset.xcSrc, active.dataset.xcSrcset);
    const img = card.querySelector('[data-xc-main]');
    if (img && img.dataset.xcOrigSrc) {
      img.setAttribute('srcset', img.dataset.xcOrigSrcset);
      img.setAttribute('src', img.dataset.xcOrigSrc);
    }
    card.classList.remove('is-previewing');
  };

  const swatchFrom = (e) => e.target.closest && e.target.closest('.xc-swatch');

  document.addEventListener('mouseover', (e) => {
    const sw = swatchFrom(e);
    if (sw) show(sw.closest('[data-xc]'), sw.dataset.xcSrc, sw.dataset.xcSrcset);
  });

  document.addEventListener('mouseout', (e) => {
    const sw = swatchFrom(e);
    if (!sw || (e.relatedTarget && sw.contains(e.relatedTarget))) return;
    restore(sw.closest('[data-xc]'));
  });

  document.addEventListener('click', (e) => {
    const sw = swatchFrom(e);
    if (!sw) return;
    e.preventDefault();
    const card = sw.closest('[data-xc]');
    const wasActive = sw.classList.contains('is-active');
    card.querySelectorAll('.xc-swatch.is-active').forEach((el) => el.classList.remove('is-active'));
    if (!wasActive) sw.classList.add('is-active');
    restore(card);
  });

  document.addEventListener('focusin', (e) => {
    const sw = swatchFrom(e);
    if (sw) show(sw.closest('[data-xc]'), sw.dataset.xcSrc, sw.dataset.xcSrcset);
  });
  document.addEventListener('focusout', (e) => {
    const sw = swatchFrom(e);
    if (sw) restore(sw.closest('[data-xc]'));
  });
})();
